export default __webpack_public_path__ + "static/media/default-user-picture.99079673.svg";